/**
 * Created by coolguy on 2017/8/10.
 */

import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('proxy');
const PROXY_LIST = "PROXY_LIST";
const PROXY_ADD = "PROXY_ADD";
const PROXY_DELETE = "PROXY_DELETE";
const PROXY_EDIT = "PROXY_EDIT";
const PROXY_DETAIL = "PROXY_DETAIL";
const PROXY_RESET = "PROXY_RESET";

export default {
    PROXY_LIST,
    proxyList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:PROXY_LIST,
                data
            })
        })
    },
    PROXY_ADD,
    proxyAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:PROXY_ADD,
                data
            })
        })
    },
    PROXY_DELETE,
    proxyDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:PROXY_DELETE,
                data,
            })
        })
    },
    PROXY_EDIT,
    proxyEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:PROXY_EDIT,
                data,
            })
        })
    },
    PROXY_DETAIL,
    proxyDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:PROXY_DETAIL,
                data,
            })
        })
    },
    PROXY_RESET,
    proxyReset:(id)=>{
        return ajaxCommon({
            api:TheApi('post')('reset'),
            data:{
                id
            },
            success:(data)=>({
                type:PROXY_RESET,
                data,
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/ProxyAction.js